import { render, staticRenderFns } from "./PickupPointPicker.vue?vue&type=template&id=bec1a060&scoped=true&"
import script from "./PickupPointPicker.vue?vue&type=script&lang=js&"
export * from "./PickupPointPicker.vue?vue&type=script&lang=js&"
import style0 from "./PickupPointPicker.vue?vue&type=style&index=0&id=bec1a060&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec1a060",
  null
  
)

export default component.exports